import { DMD_BRAND } from '../alliance/alliance-tokens';

/** Text color of an inactive sidebar row */
export const NAV_ROW_TEXT = '#1b1c1d';

/**
 * Styles for a sidebar row (a ListItemButton): 44px (40px nested), a 4px
 * left border that turns DMD blue on the active row, and a rounded right
 * end. The active row is #eef4ff with bold #1f56d6 text (5.7:1), per the DMD
 * App System sidebar tokens.
 *
 * @param active - The row's route is the current page
 * @param depth - 0 for a section, 1 for its links, 2 for nested links
 */
export const navRowSx = (params: { active?: boolean; depth: number }) => {
  // Params
  const { active, depth } = params;

  return {
    minHeight: depth ? 40 : 44,
    py: 0,
    pl: `${12 + depth * 16}px`,
    pr: '12px',
    borderLeft: `4px solid ${
      active ? DMD_BRAND.sidebar.activeBorder : 'transparent'
    }`,
    borderRadius: '0 10px 10px 0',
    backgroundColor: active ? DMD_BRAND.sidebar.activeBg : 'transparent',
    color: active ? DMD_BRAND.sidebar.activeText : NAV_ROW_TEXT,
    fontSize: depth ? 14 : 15,
    fontWeight: active ? 700 : depth ? 400 : 500,
    transition: 'background-color 0.15s',
    '&:hover': {
      backgroundColor: active ? DMD_BRAND.sidebar.activeBg : '#0000000a',
    },
    '&.Mui-focusVisible': {
      outline: `2px solid ${DMD_BRAND.progress}`,
      outlineOffset: -2,
    },
  };
};
